// extracted by mini-css-extract-plugin
module.exports = {"menuModal":"menu-modal_menuModal__FfFs0"};